import React from "react";
import { FaQuoteLeft } from "react-icons/fa";

const quotes = [
  {
    quote:
      "Qeverisja ishte e lehtë: përditësime javore me shkrim, demonstrime që përputheshin me roadmap-in dhe një paketë kalimi që ekipi ynë e përdorte menjëherë.",
    name: "Elena M.",
    role: "VP Produkti",
    org: "B2B SaaS · Bashkimi Evropian",
  },
  {
    quote:
      "E matëm suksesin me qëndrueshmëri dhe shpejtësi. Hedhjet u bënë ‘të mërzitshme’ — në kuptimin më të mirë — dhe palët e interesuara pushuan të shuajnë zjarre.",
    name: "James R.",
    role: "Shef Teknologjie",
    org: "Fintech · Seri B",
  },
  {
    quote:
      "Dizajni dhe inxhinieria përdornin të njëjtin sistem. Kjo përputhje shkurtoi ciklet e shqyrtimit dhe i dha marketingut besim në atë që dilte.",
    name: "Sofia K.",
    role: "Drejtoreshë Marketingu",
    org: "Retail & e-commerce",
  },
];

function Testimonials() {
  return (
    <section className="testimonials section-pad" id="testimonials">
      <div className="container">
        <div className="section-heading">
          <span className="section-tag">Zëri i klientit</span>
          <h2>Të besuar nga drejtues produkti dhe teknologjie</h2>
          <p>
            Identitetet janë anonimizuar kur zbatohet konfidencialiteti. Përmbledhjet pasqyrojnë
            temat e përsëritura nga angazhime afatgjata.
          </p>
        </div>

        <div className="testimonials-grid">
          {quotes.map(({ quote, name, role, org }) => (
            <blockquote key={name} className="testimonial-card">
              <FaQuoteLeft className="testimonial-quote-icon" aria-hidden="true" />
              <p className="testimonial-quote">{quote}</p>
              <footer className="testimonial-footer">
                <cite className="testimonial-name">{name}</cite>
                <span className="testimonial-meta">
                  {role} · {org}
                </span>
              </footer>
            </blockquote>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Testimonials;
